import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ServiceAreas from "./pages/ServiceAreas";
import ServiceArea from "./pages/ServiceArea";
import JoinOurTeam from "./pages/JoinOurTeam";
import Legal from "./pages/Legal";
import Espanol from "./pages/Espanol";
import InsuranceClaims from "./pages/InsuranceClaims";
import Financing from "./pages/Financing";
import LifecyclePlan from "./pages/LifecyclePlan";
import RoofCost from "./pages/RoofCost";
import WarrantyClaim from "./pages/WarrantyClaim";
import Remodeling from "./pages/Remodeling";
import Painting from "./pages/Painting";
import AtticRoofline from "./pages/AtticRoofline";
import WarrantyGuide from "./pages/WarrantyGuide";
import MakePayment from "./pages/MakePayment";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import MobileCallBar from "./components/MobileCallBar";
import ConsentBanner from "./components/ConsentBanner";
import NotFound from "./pages/NotFound";

// Shared by the browser app and the pre-renderer (scripts/prerender.mjs)
export const AppShell = () => (
  <div className="App">
    {/* WCAG 2.4.1 Bypass Blocks. The header carries 70-odd links before the
        page content starts; without this, a keyboard or screen-reader user
        tabs through every one of them on every page. Visually hidden until
        focused, then it appears over the header. */}
    <a href="#main" className="skip-link">Skip to main content</a>
    <Header />
    <main id="main" tabIndex={-1}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/service-areas" element={<ServiceAreas />} />
        <Route path="/service-areas/:slug" element={<ServiceArea />} />
        <Route path="/about" element={<About />} />
        <Route path="/join-our-team" element={<JoinOurTeam />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/espanol" element={<Espanol />} />
        <Route path="/insurance-claims" element={<InsuranceClaims />} />
        <Route path="/financing" element={<Financing />} />
        <Route path="/lifecycle-plan" element={<LifecyclePlan />} />
        <Route path="/roof-replacement-cost" element={<RoofCost />} />
        <Route path="/warranty-claim" element={<WarrantyClaim />} />
        {/* The page itself redirects away while remodeling.enabled is false,
            so the route can stay mounted either way. */}
        <Route path="/remodeling" element={<Remodeling />} />
        <Route path="/painting" element={<Painting />} />
        <Route path="/attic-roofline" element={<AtticRoofline />} />
        <Route path="/understanding-your-warranty" element={<WarrantyGuide />} />
        <Route path="/make-a-payment" element={<MakePayment />} />
        <Route path="/resources" element={<Blog />} />
        <Route path="/resources/:slug" element={<BlogPost />} />
        <Route path="/:slug" element={<Legal />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
    <Footer />
    <MobileCallBar />
    <ConsentBanner />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
